// TODO (WEB-11690): This should be included in the Tiptap extensions cleanup task
//  These lists are used when creating content outside of the client side editor
//  Their hooks should probably use these lists somehow too
// Lib
import { TextAlign } from './TextAlign';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import { TextStyle } from './TextStyle';
import { TextColor } from './TextColor';
import { TextHighlight } from './TextHighlight';
import { OldMention } from './mention/OldMention';
import { TextMention } from './mention/TextMention';
import { LegacyTaskList } from './LegacyTaskList';
import { Heading } from './Heading';
import { LegacyTaskItem } from './LegacyTaskItem';
import { Link } from './hyperlink/Link';
import { CodeMark } from './CodeMark';
import { CodeBlock } from './CodeBlock';
import { Callout } from './Callout';
import { InlineBoardLink } from './inlineBoardLink/InlineBoardLink';
import { InlineComment } from './inlineComment/InlineComment';

// NOTE: The single-editor task list's lists are in `taskList/taskListExtensionLists.ts`, not here.
//  They carry rules of their own - a looser document for parsing pasted content, a strict one for
//  a stored document - which belong beside the task list rather than in this general file.

export const CAPTION_STATIC_TIPTAP_EXTENSIONS = [
    StarterKit.configure({
        heading: false,
        code: false,
        codeBlock: false,
        blockquote: false,
        bulletList: false,
        orderedList: false,
        horizontalRule: false,
    }),
    TextAlign,
    Underline,
    TextStyle,
    TextColor,
    TextHighlight,
    OldMention,
    TextMention,
    Link,
    CodeMark,
];

export const CARD_STATIC_TIPTAP_EXTENSIONS = [
    StarterKit.configure({
        heading: false,
        horizontalRule: false,
        code: false,
        codeBlock: false,
    }),
    Heading,
    CodeBlock,
    CodeMark,
    TextAlign,
    Underline,
    TextStyle,
    TextColor,
    TextHighlight,
    OldMention,
    TextMention,
    Link,
    LegacyTaskList,
    LegacyTaskItem,
    Callout,
    InlineBoardLink,
    InlineComment,
];

export const TASK_STATIC_TIPTAP_EXTENSIONS = [
    StarterKit.configure({
        heading: false,
        codeBlock: false,
        code: false,
        blockquote: false,
        bulletList: false,
        orderedList: false,
        horizontalRule: false,
        listItem: false,
    }),
    Underline,
    Link,
    CodeMark,
];
